import { render } from "./EditSpecialMarket.vue?vue&type=template&id=5d6fdfec"
import script from "./EditSpecialMarket.vue?vue&type=script&lang=js"
export * from "./EditSpecialMarket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__